import { MockDb } from '../../../../mockDb';

const db = new MockDb('brand', [
  { id: 1, name: "TATA", code: "BRD-001", status: "Active", createdDate: "May 10, 2026" },
  { id: 2, name: "Samsung", code: "BRD-002", status: "Active", createdDate: "May 12, 2026" },
  { id: 3, name: "Apple", code: "BRD-003", status: "Active", createdDate: "May 14, 2026" },
  { id: 4, name: "Nike", code: "BRD-004", status: "Active", createdDate: "May 16, 2026" },
]);

export async function listBrands(params = {}) {
  await new Promise(r => setTimeout(r, 100));
  let list = db.getAll();
  
  if (params.viewMode === 'active') {
    list = list.filter(item => item.status === 'Active');
  } else if (params.viewMode === 'archived') {
    list = list.filter(item => item.status !== 'Active');
  }

  if (params.searchText) {
    const q = params.searchText.toLowerCase().trim();
    list = list.filter(item => 
      (item.name && item.name.toLowerCase().includes(q)) || 
      (item.code && item.code.toLowerCase().includes(q))
    );
  }

  return list;
}

export async function getBrandDetail(brandId) {
  await new Promise(r => setTimeout(r, 100));
  return db.get(brandId);
}

export async function createBrand(payload) {
  await new Promise(r => setTimeout(r, 100));
  return db.create(payload);
}

export async function updateBrand(brandId, payload) {
  await new Promise(r => setTimeout(r, 100));
  return db.update(brandId, payload);
}

export async function archiveBrand(brandId) {
  await new Promise(r => setTimeout(r, 100));
  return db.archive(brandId);
}

export async function deleteBrand(brandId) {
  await new Promise(r => setTimeout(r, 100));
  return db.delete(brandId);
}
